import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';  

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { IconsModule } from '@progress/kendo-angular-icons';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { GridModule } from '@progress/kendo-angular-grid';
import { InputsModule } from '@progress/kendo-angular-inputs';

import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { LandingPageComponent } from './landing-page/landing-page.component';

import { SkipChatModule } from '@memberjunction/ng-skip-chat';
import { ContainerDirectivesModule } from '@memberjunction/ng-container-directives';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';

import { NewOrganizationComponent } from './onboarding/new-organization/new-organization.component';
import { PricingComponent } from './onboarding/pricing/pricing.component';
import { CheckoutComponent } from './onboarding/checkout/checkout.component';
import { ConnectorComponent } from './onboarding/connector/connector.component';
import { WaitingPageComponent } from './onboarding/waiting-page/waiting-page.component';

import { AdminBannerComponent } from './dashboard/admin-banner/admin-banner.component';

import { HeaderComponent } from './dashboard/header/header.component';
import { SkipComponent } from './dashboard/skip/skip.component';
import { SingleReportComponent } from './dashboard/single-report/single-report.component';
import { ReportListComponent } from './dashboard/report-list/report-list.component';
import { NoInstanceComponent } from './dashboard/no-instance/no-instance.component';

import { SettingsComponent } from './settings/settings.component';
import { ProfileSettingsComponent } from './settings/profile/profile.component';
import { TeamSettingsComponent } from './settings/team/team.component';
import { ConnectorsSettingsComponent } from './settings/connector/connector.component';
import { SecuritySettingsComponent } from './settings/security/security.component';
import { OrganizationsSettingsComponent } from './settings/organizations/organizations.component';
import { SubscriptionListComponent } from './settings/subscription-list/subscription-list.component';
import { SubscriptionDetailComponent } from './settings/subscription-detail/subscription-detail.component';
import { SubscriptionUpdateComponent } from './settings/subscription-update/subscription-update.component';
import { InternalAdminSettingsComponent } from './settings/internal-admin/internal-admin.component';
import { InstanceListComponent } from './settings/instance-list/instance-list.component';
import { InstanceDetailComponent } from './settings/instance-detail/instance-detail.component';
import { SubscriptionEditPaymentComponent } from './settings/subscription-edit-payment/subscription-edit-payment.component';
import { SubscriptionUpdatePreviewComponent } from './settings/subscription-update-preview/subscription-update-preview.component';

import { ResourcePermissionsModule } from '@memberjunction/ng-resource-permissions';
import { MJNotificationsModule } from '@memberjunction/ng-notifications';
import { DashboardRedirectComponent } from './dashboard/dashboard-redirect-component';
import { InstanceDropdownComponent } from './dashboard/header/instance-dropdown-component';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';



@NgModule({
  declarations: [
    AppComponent,
    LandingPageComponent,
    DashboardRedirectComponent,
    PricingComponent,
    CheckoutComponent,
    ConnectorComponent,
    AdminBannerComponent,
    HeaderComponent,
    SkipComponent,
    SingleReportComponent,
    ReportListComponent,
    NoInstanceComponent,
    SettingsComponent,
    ProfileSettingsComponent,
    OrganizationsSettingsComponent,
    TeamSettingsComponent,
    ConnectorsSettingsComponent,
    SecuritySettingsComponent,
    InstanceListComponent,
    InstanceDetailComponent,
    NewOrganizationComponent,
    WaitingPageComponent,
    InstanceDropdownComponent,
    InternalAdminSettingsComponent,
    SubscriptionListComponent,
    SubscriptionDetailComponent,
    SubscriptionUpdateComponent,
    SubscriptionUpdatePreviewComponent,
    SubscriptionEditPaymentComponent
  ],
  imports: [
    CoreModule,
    SharedModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    LayoutModule,
    ButtonsModule,
    IconsModule,
    NotificationModule,
    DialogModule,
    GridModule,
    SkipChatModule,
    ContainerDirectivesModule,
    TreeViewModule,
    IndicatorsModule,
    ResourcePermissionsModule,
    MJNotificationsModule,
    DropDownsModule,
    DateInputsModule,
    InputsModule
  ],
  providers: [
    CurrencyPipe, 
    DecimalPipe
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { 
}



